import {convertWallBasedPositioningToCoordinates} from '../helpers/stovePositionConverter';

var initialState =
{
    doorWallWidth:"",
    depth: "",
    height: "",
    doorWidth: "",
    doorHeight: 1850,
    doorHandness:"right",
    upGlassHeight:300,
    upGlassEnabled: true,
    leftSideGlassEnabled: true,
    leftSideGlassWidth: 800,
    leftSideGlassHeight: 1000,
    rightSideGlassEnabled: true,
    rightSideGlassWidth: 800,
    rightSideGlassHeight: 1000,
    spaceUnderDoor:120,
    doorFromLeft: 0,
    defaultDoorFromLeft: 0,
    skipped: false,
    stovePosition: { x: 325 , y: 325 },
    defaultStovePosition: { x: 325, y: 325 },
    glassMaterial: 1,
    doorSizeConstraints: {
        leftSideGlassMinWidth: 100,
        leftSideGlassMaxWidth: 1000,
        leftSideGlassMinHeight: 200,
        leftSideGlassMaxHeight: 2000,
        rightSideGlassMinWidth: 100,
        rightSideGlassMaxWidth: 1000,
        rightSideGlassMinHeight: 2000,
        rightSideGlassMaxHeight: 2000,
        minUpGlassHeight: 100,
        maxUpGlassHeight: 500,
        allowAddOrRemoveGlass: true
    },
    glassListMaterial:1,
    glassWallInitialized: false,
    doorType: "customGlassWall",
    positioningSkipped: false,
    comment:"",
    floorImage:[]
   
}
const measurements = (state = initialState, action) => {
    let newDoorHeight;
    switch (action.type) {
        case 'ROOM_MEASUREMENTS_UPDATED':
            newDoorHeight = action.measurements.height - state.spaceUnderDoor - state.upGlassHeight;
            let nState = { ...state, ...action.measurements }
            nState.doorHeight = newDoorHeight
            return nState;
      //      return { ...state, ...action.measurements,..{ doorHeight: newDoorHeight } }
        case 'DOORMATERIAL_CHANGED':
            return Object.assign({}, state, {
                glassMaterial: action.material
            })
        case 'GLASSLIST_MATERIAL_CHANGED':
            return Object.assign({}, state, {
                glassListMaterial: action.materialId
            })

        case 'MEASUREMENTS_SKIPPED':
            return Object.assign({}, state, {
                skipped: true
            })
        case 'MEASUREMENTS_GIVEN':
            return Object.assign({}, state, {
                skipped: false
            })
        case 'DOORFROMLEFT_UPDATED':
            return Object.assign({}, state, {
                doorFromLeft: action.doorFromLeft
            })
        case 'LEFTSIDEGLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                leftSideGlassHeight: action.height
            })
        case 'STOVEPOSITION_UPDATED':
            return Object.assign({}, state, {
                stovePosition: action.stovePosition
            })
        case 'POSITIONING_DEFAULTS_SET':
            return Object.assign({}, state, {
                defaultDoorFromLeft: action.doorFromLeft,
                defaultStovePosition: action.stovePosition
            })
        case 'UPDATE_SAUNACADIMAGE':
            return Object.assign({}, state, {          
                cadImageUpdatePending: true
            })
        case 'SAUNACADIMAGE_UPDATED':
            return Object.assign({}, state, {
                cadImage: action.image,
                cadImageUpdatePending: false
            })
        case 'PLAN_LOADED': {
            const doorWallWidth = action.plan.saunaWidth !== undefined ? action.plan.saunaWidth : action.plan.SaunaWidth;
            const saunaDepth = action.plan.saunaDepth !== undefined ? action.plan.saunaDepth : action.plan.SaunaDepth;
            const saunaHeight = action.plan.saunaHeight !== undefined ? action.plan.saunaHeight : action.plan.SaunaHeight;
            const doorWidth = action.plan.doorWidth !== undefined ? action.plan.doorWidth : action.plan.DoorWidth;
            const doorFromLeft = action.plan.doorfromLeft !== undefined ? action.plan.doorfromLeft : action.plan.DoorfromLeft;
            const stovePosition = action.plan.stovePosition || convertWallBasedPositioningToCoordinates(
                action.plan.stoveWall || action.plan.StoveWall,
                action.plan.stoveFromLeft !== undefined ? action.plan.stoveFromLeft : action.plan.StoveFromLeft,
                doorWallWidth,
                saunaDepth
            );
            return Object.assign({}, state, {
                doorWallWidth: doorWallWidth,
                depth: saunaDepth,
                height: saunaHeight,
                doorWidth: doorWidth,
                doorFromLeft: doorFromLeft,
                defaultDoorFromLeft: doorFromLeft,
                stovePosition: stovePosition,
                defaultStovePosition: stovePosition
            })
        }
        case 'DOOR_TYPE_CHANGED':
            return Object.assign({}, state, {
                doorType: action.doorType
            })
        case 'GLASS_WALL_EDITED':
            return Object.assign({}, state, {
                glassWallInitialized: true
            })
        case 'RESTORE_DEFAULT_GLASS_WALL':
            return Object.assign({}, state, {
                leftSideGlassEnabled: action.defaults.leftSideGlassEnabled,
                leftSideGlassHeight: action.defaults.leftSideGlassHeight,
                leftSideGlassWidth: action.defaults.leftSideGlassWidth,
                rightSideGlassEnabled: action.defaults.rightSideGlassEnabled,
                rightSideGlassHeight: action.defaults.rightSideGlassHeight,
                rightSideGlassWidth: action.defaults.rightSideGlassWidth,
                upGlassEnabled: action.defaults.upGlassEnabled,
                upGlassHeight: action.defaults.upGlassHeight,
                doorHeight: action.defaults.doorHeight,
                spaceUnderDoor: action.defaults.spaceUnderDoor
            })
        case 'UPDATE_DOORSIZE_CONSTRAINTS':
            return Object.assign({}, state, {
                doorSizeConstraints: action.doorSizeConstraints
            })

        case 'CHANGE_DOOR_HANDNESS':
            return Object.assign({}, state, {
                doorHandness: state.doorHandness == "right" ? "left" : "right"
            })               

        case 'LEFTSIDEGLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                leftSideGlassHeight: action.height
            })
        case 'LEFTSIDEGLASS_WIDTH_CHANGED':
            return Object.assign({}, state, {
                leftSideGlassWidth: action.width
            })
        case 'TOGGLE_LEFTSIDEGLASS':
            return Object.assign({}, state, {
                leftSideGlassEnabled: !state.leftSideGlassEnabled
            })
        case 'RIGHTSIDEGLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                rightSideGlassHeight: action.height
            })
        case 'RIGHTSIDEGLASS_WIDTH_CHANGED':
            return Object.assign({}, state, {
                rightSideGlassWidth: action.width
            })
        case 'TOGGLE_RIGHTSIDEGLASS':
            return Object.assign({}, state, {
                rightSideGlassEnabled: !state.rightSideGlassEnabled
            })
        case 'TOGGLE_UPGLASS':
            return Object.assign({}, state, {
                upGlassEnabled: !state.upGlassEnabled
            })
        case 'DOOR_HEIGHT_CHANGED':
            let newSpaceUnderDoor = state.height - action.height - state.upGlassHeight;
            return Object.assign({}, state, {
                doorHeight: action.height,
                spaceUnderDoor: newSpaceUnderDoor
            })
        case 'SPACE_UNDER_DOOR_CHANGED':
             newDoorHeight = state.height - action.height - state.upGlassHeight;
            return Object.assign({}, state, {
                spaceUnderDoor: action.height,
                doorHeight: newDoorHeight
            })            
        case 'UP_GLASS_HEIGHT_CHANGED':
             newDoorHeight = state.height - action.height - state.spaceUnderDoor;
            return Object.assign({}, state, {
                upGlassHeight: action.height,
                doorHeight: newDoorHeight
            })
        case 'UPDATE_POSITIONING_SKIPPED':
            return Object.assign({}, state, {
                positioningSkipped: action.value 
            });
        default:
            return state;
    }
}
export default measurements
